// import Background from 'formstone/jquery/background';
// import Checkpoint from 'formstone/jquery/checkpoint';
import Cookie from 'formstone/jquery/cookie';
import Lightbox from 'formstone/jquery/lightbox';
import MediaQuery from 'formstone/jquery/mediaquery';
// import Modal from 'formstone/jquery/modal';
import Navigation from 'formstone/jquery/navigation';
import Swap from 'formstone/jquery/swap';

window.Debounce = (callback, timeout) => {
  let timer = null;

  return (...args) => {
    window.clearTimeout(timer);

    timer = window.setTimeout(() => {
      callback(...args);
    }, timeout);
  };
};

window.SiteReady(($) => {
  console.log('Init: Main Site');

  const $window = $(window);
  const $body = $('body');

  // Scroll

  let newScroll = -1;
  let lastScroll = 0;
  let newShift = -1;
  const lastShift = 100;

  function onScroll() {
    newScroll = $window.scrollTop();
    newShift = newScroll;

    window.requestAnimationFrame(onRAF);
  }

  function onRAF() {
    if (newScroll != lastScroll) {
      const scrollDir = (newScroll < lastScroll) ? 'up' : 'down';

      if (newScroll > 0) {
        $body.addClass('scrolled');
      } else {
        $body.removeClass('scrolled');
      }

      lastScroll = newScroll;
    }

    // window.requestAnimationFrame(onRAF);
  }

  $window.on('scroll', onScroll);
  // window.requestAnimationFrame(onRAF);

  onScroll();

  // Desktop Nav

  $('.js-desktop_nav li.menu-item-has-children').on('mouseenter focusin', (e) => {
    $('.js-header_search_handle').swap('deactivate');
  });

  $('.js-header_search_handle').on('swap:activate', (e) => {
    setTimeout(() => {
      $('#header_search_tray input').eq(0).focus();
    }, 50);
  });

  $('.js-header').on('focusout', function(e) {
    if (!this.contains(e.relatedTarget)) {
      $('.js-header_search_handle').swap('deactivate');
    }
  });

  $window.on('keydown', function(e) {
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
      e.preventDefault();

      $('.js-header_search_handle').swap('activate');
    }
  });

  // $('.js-desktop_nav li.menu-item-has-children').on('mouseenter focusin', (e) => {
  //   let $el = $(e.currentTarget);

  //   $('.js-desktop_nav li').removeClass('open');

  //   $el.addClass('open');
  // }).on('mouseleave focusout', (e) => {
  //   $('.js-desktop_nav li').removeClass('open');
  // });

  // Mobile Nav

  $('.js-mobile_menu .menu > .menu-item-has-children > a').each((linkIndex, link) => {
    const $link = $(link);
    const $parent = $link.parent('li');
    const active = ($parent.hasClass('current-menu-item') || $parent.hasClass('current-menu-ancestor'));
    let html = '';
    let linkClass = 'js-nav_toggle_' + linkIndex;

    html += '<button type="button" class="mobile_toggle_handle js-swap js-nav_toggle';
    if (active) {
      linkClass += ' fs-swap-active';
      html += ' fs-swap-active';
    }
    html += '" data-swap-target=".js-nav_toggle_' + linkIndex + '"';
    if (active) {
      html += ' data-swap-active="true"';
    }
    html += '><span class="screenreader">Open Menu</span></button>';

    $link.append(html).next('.sub-menu').addClass(linkClass);
  });

  $('.js-mobile_menu').on('navigation:open', function() {
    $('.js-mobile_menu').scrollTop(0);
  });


  // Filter Groups

  // $('.js-filter_group .js-filter_button').on('click', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   // let $select = $parent.find('.js-filter_select');
  //   let $items = $parent.find('.js-filter_item');
  //   let active = $target.data('filter');

  //   $buttons.removeClass('active');
  //   $target.addClass('active');

  //   if (active == 'all') {
  //     $items.show();
  //   } else {
  //     $items.hide().filter('[data-filter="' + active + '"]').show();
  //   }
  // });

  // $('.js-filter_group .js-filter_select').on('change', (e) => {
  //   let $target = $(e.currentTarget);
  //   let $parent = $target.parents('.js-filter_group');
  //   let $buttons = $parent.find('.js-filter_button');
  //   let active = $target.val();

  //   $buttons.filter('[data-filter="' + active + '"]').trigger('click');
  // });

  // //

  // $('.js-filter_form select').on('change', (e) => {
  //   let $target = $(e.currentTarget);
  //   let label = $target.find('option:selected').data('label');

  //   $target[0].dataset.selected = $target.val();
  //   $target.next('.js-filter_spacer').text(label);

  //   $target.parents('form').submit();
  // });

  // Scroll Next

  $('.js-scroll_next').on('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const $parent = $(e.currentTarget).parents('.js-scroll_next_parent');

    const height = $parent.outerHeight() - (window.scrollY - $parent[0].offsetTop);

    window.scrollDistance(height);
  });

  // // Search Modal

  // $('.js-search_modal').on('swap:activate', (e) => {
  //   let $target = $(e.currentTarget);

  //   setTimeout(() => {
  //     $target.find('input[type="text"]').first().focus();
  //   }, 50);
  // });

  // Resize

  const onResize = window.Debounce(function() {
    const height = $window.outerHeight();
    const width = $window.outerWidth();

    if ( height >= width ) {
      $('html').removeClass('is-landscape').addClass('is-portrait');
    } else {
      $('html').removeClass('is-portrait').addClass('is-landscape');
    }
  }, 100);

  $window.on('resize', onResize);

  onResize();

  // Plugins

  $('.js-navigation').navigation();
  // $('.js-background').background();
  $('.js-swap').swap();
  $('.js-lightbox').lightbox();
  // $('.js-modal').modal();
  // $('.js-tabs').tabs();

  // $('.js-checkpoint, [data-checkpoint-animation]').checkpoint({
  //   offset: '100px',
  //   reverse: true
  // });

  // $('.has_ornament').checkpoint({
  //   offset: '30%',
  //   reverse: true
  // });

  // $('.js-icon').checkpoint({
  //   offset: '140px',
  //   reverse: true
  // });

  // // Forms

  // $(document).on('gform_confirmation_loaded gform_page_loaded', function(e, form) {
  //   window.scrollToElement('#gf_' + form);
  // });

  // // Exit intent

  // $('.js-modal[data-modal-options]').each((index, el) => {
  //   let $el = $(el);
  //   let data = $el.data('modal-options');

  //   let onload = $.cookie('get', data.id + '-onload');
  //   let onexit = $.cookie('get', data.id + '-exit');

  //   if (data.onLoad && onload != 'true') {
  //     el.dispatchEvent(new CustomEvent('click'));

  //     $.cookie('set', data.id + '-onload', 'true', {
  //       path: '/',
  //       expires: (1000 * 60 * 60 * 24), // 24 hours
  //     });
  //   }

  //   $(window).on('modal:open', () => {
  //     console.log('Modal open');
  //   });

  //   if (data.exitIntent) {
  //     $window.on('exitintent', (e) => {
  //       if (onexit !== 'true') {
  //         if ($('.fs-modal.is_drawer').length <= 0) {
  //           el.dispatchEvent(new CustomEvent('click'));
  //         }

  //         $.cookie('set', data.id + '-exit', 'true', {
  //           path: '/',
  //           expires: (1000 * 60 * 60 * 24), // 24 hours
  //         });

  //         onexit = 'true';
  //       }
  //     });
  //   }
  // });

  // Tables

  $('.wp-block-table').find('table').wrap('<div class="table_wrapper"></div>');

  //

  $('iframe[src*="youtube"]').each((_, iframe) => {
    const $iframe = $(iframe);

    if ($iframe.parents('.video-wrapper, .video_frame').length == 0) {
      $iframe.wrap('<div class="video-wrapper"></div>');
    }
  });

});